// Keep native Horizon modules, but fetch component features only when their
// markup exists. Section rendering and theme editor additions use the same path.
const config = document.getElementById('anwra-feature-modules');
if (config) {
  const features = JSON.parse(config.textContent);
  const byTag = new Map();
  const loads = new Map();
  for (const feature of features) {
    for (const tag of feature.tags) {
      if (!byTag.has(tag)) byTag.set(tag, []);
      byTag.get(tag).push(feature.url);
    }
  }
  const selector = [...byTag.keys()].join(',');
  const load = url => {
    if (loads.has(url)) return;
    loads.set(url, 'loading');
    import(url).then(() => loads.set(url, 'loaded')).catch(error => {
      loads.set(url, 'failed');
      console.warn('[Anwra] Component module could not load.', error);
    });
  };
  const visit = element => {
    for (const url of byTag.get(element.localName) || []) load(url);
  };
  const scan = root => {
    if (!(root instanceof Element)) return;
    visit(root);
    root.querySelectorAll(selector).forEach(visit);
  };
  // Observe before scanning so fragments inserted during initial registration
  // are not lost. Inspect added subtrees rather than rescanning the document.
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan(document.documentElement);
  window.addEventListener('online', () => {
    for (const [url, status] of loads) if (status === 'failed') loads.delete(url);
    scan(document.documentElement);
  });
}
